import { render, staticRenderFns } from "./NormalSearchNav163.vue?vue&type=template&id=47fa201e&scoped=true"
import script from "./NormalSearchNav163.vue?vue&type=script&lang=js"
export * from "./NormalSearchNav163.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47fa201e",
  null
  
)

export default component.exports